import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/app/src/pages/.umi-production/LocaleWrapper.jsx';
import { routerRedux, dynamic as _dvaDynamic } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/user',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__UserLayout" */ '../../layouts/UserLayout'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/UserLayout').default,
    cannotRedirectTo: true,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__login" */ '../user/login'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/login').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'twoFactor',
        path: '/user/two-factor',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__two-factor" */ '../user/two-factor'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/two-factor').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'phoneVerification',
        path: '/user/phone-verification',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__phone-verification" */ '../user/phone-verification'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/phone-verification').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'register',
        path: '/user/register',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__register" */ '../user/register'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/register').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'confirmEmail',
        path: '/user/confirm-email',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__confirmEmail" */ '../user/confirmEmail'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/confirmEmail').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'dealer',
        path: '/user/register/dealer',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__register__dealer" */ '../user/register/dealer'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/register/dealer').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'forgotPassword',
        path: '/user/forgotPassword',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__forgotPassword__" */ '../user/forgotPassword'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/forgotPassword').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
      {
        name: 'restPassword',
        path: '/user/reset-password',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__user__resetPassword__" */ '../user/resetPassword'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../user/resetPassword').default,
        cannotRedirectTo: true,
        public: true,
        exact: true,
      },
    ],
  },
  {
    path: '/invite',
    component: __IS_BROWSER
      ? _dvaDynamic({
          app: require('@tmp/dva').getApp(),
          models: () => [
            import(/* webpackChunkName: 'p__InviteUser__model.js' */ '/app/src/pages/InviteUser/model.js').then(
              m => {
                return { namespace: 'model', ...m.default };
              },
            ),
          ],
          component: () =>
            import(/* webpackChunkName: "p__InviteUser" */ '../InviteUser'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../InviteUser').default,
    cannotRedirectTo: true,
    public: true,
    exact: true,
  },
  {
    path: '/redirect/secure-pass',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__SecurePass__SecurePassLogger__SecurePassLogger" */ '../SecurePass/SecurePassLogger/SecurePassLogger'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../SecurePass/SecurePassLogger/SecurePassLogger').default,
    hideInMenu: true,
    public: true,
    exact: true,
  },
  {
    path: '/secure-pass',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "p__SecurePass__SecurePass" */ '../SecurePass/SecurePass'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../SecurePass/SecurePass').default,
    hideInMenu: true,
    public: true,
    exact: true,
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__MaintenanceModeLayout" */ '../../layouts/MaintenanceModeLayout'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/MaintenanceModeLayout').default,
    cannotRedirectTo: true,
    routes: [
      {
        path: '/redirect/quick-quote',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__QuickQuoteRedirect" */ '../QuickQuoteRedirect'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../QuickQuoteRedirect').default,
        hideInMenu: true,
        exact: true,
      },
      {
        path: '/redirect/create-shipment',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__CreateShipmentRedirect" */ '../CreateShipmentRedirect'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../CreateShipmentRedirect').default,
        hideInMenu: true,
        exact: true,
      },
      {
        path: '/invite-existing',
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__InviteUser__model.js' */ '/app/src/pages/InviteUser/model.js').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__InviteUser" */ '../InviteUser'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../InviteUser').default,
        cannotRedirectTo: true,
        exact: true,
      },
      {
        path: '/change-temp-password',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__ChangeTempPassword" */ '../ChangeTempPassword'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../ChangeTempPassword').default,
        cannotRedirectTo: true,
        exact: true,
      },
      {
        path: '/',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "layouts__BasicLayout" */ '../../layouts/BasicLayout'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../../layouts/BasicLayout').default,
        authority: true,
        routes: [
          {
            path: '/',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "layouts__RedirectLayout" */ '../../layouts/RedirectLayout'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../../layouts/RedirectLayout').default,
            authority: true,
            cannotRedirectTo: true,
            exact: true,
          },
          {
            name: 'Dashboard',
            icon: 'dashboard',
            path: '/dashboard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Dashboard__model.js' */ '/app/src/pages/Dashboard/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Dashboard" */ '../Dashboard'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Dashboard').default,
            authority: [
              'CoreService.Dashboards.Dealer',
              'CoreService.Dashboards.Transporter',
            ],
            exact: true,
          },
          {
            name: 'Dashboard',
            path: '/admin/dashboard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminDashboard__model.js' */ '/app/src/pages/AdminDashboard/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminDashboard" */ '../AdminDashboard'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminDashboard').default,
            icon: 'dashboard',
            authority: ['CoreService.Dashboards.Admin'],
            exact: true,
          },
          {
            name: 'BDM Dashboard',
            path: '/bdm/dashboard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__BDMDashboard__model.js' */ '/app/src/pages/BDMDashboard/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__BDMDashboard" */ '../BDMDashboard'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../BDMDashboard').default,
            icon: 'dashboard',
            authority: ['CoreService.Dashboards.BDM'],
            exact: true,
          },
          {
            name: 'Quick Quote',
            icon: 'Thunder',
            path: '/quick-quotes',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__QuickQuotes" */ '../QuickQuotes'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../QuickQuotes').default,
            authority: ['PricingService.QuickQuotes.Create'],
            exact: true,
          },
          {
            name: 'Quick Quotes',
            icon: 'AdminQuickQuotes',
            path: '/admin/quick-quotes',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminQuickQuotes" */ '../AdminQuickQuotes'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminQuickQuotes').default,
            qs: 'source=menu',
            authority: ['PricingService.QuickQuotesAdmin'],
            exact: true,
          },
          {
            name: 'Shipments',
            icon: 'carry-out',
            path: '/admin/shipments',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminShipments" */ '../AdminShipments'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminShipments').default,
            authority: ['CoreService.AdminShipments'],
            exact: true,
          },
          {
            name: 'Shipment View',
            path: '/admin/shipments/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminShipments__AdminShipmentView__model.js' */ '/app/src/pages/AdminShipments/AdminShipmentView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminShipments__AdminShipmentView" */ '../AdminShipments/AdminShipmentView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminShipments/AdminShipmentView').default,
            authority: ['CoreService.AdminShipments'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Messages',
            path: '/admin/shipments/view/messages',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__PricingEngineMessages" */ '../PricingEngineMessages'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../PricingEngineMessages').default,
            authority: ['PricingService.QuoteRuleResults'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Create Shipment',
            path: '/admin/shipments/create',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__CreateShipment" */ '../CreateShipment'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../CreateShipment').default,
            authority: ['CoreService.AdminShipments'],
            hideInMenu: true,
            cannotRedirectTo: true,
            exact: true,
          },
          {
            name: 'Edit Shipment',
            path: '/admin/shipments/edit',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__ShipmentList__EditShipment__model.js' */ '/app/src/pages/ShipmentList/EditShipment/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__ShipmentList__EditShipment" */ '../ShipmentList/EditShipment'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../ShipmentList/EditShipment').default,
            authority: ['CoreService.AdminShipments'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Create Shipment',
            icon: 'plus',
            path: '/create',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__CreateShipment" */ '../CreateShipment'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../CreateShipment').default,
            authority: ['CoreService.Shipments.Create'],
            cannotRedirectTo: true,
            exact: true,
          },
          {
            name: 'Quick Quotes',
            path: '/my-quick-quotes',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__DealerQuickQuotes" */ '../DealerQuickQuotes'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../DealerQuickQuotes').default,
            hideInMenu: true,
            authority: ['PricingService.QuickQuotes'],
            exact: true,
          },
          {
            name: 'Quotes',
            icon: 'file-search',
            path: '/quotes',
            authority: ['CoreService.Quotes'],
            routes: [
              {
                name: 'Single Quote View',
                path: '/quotes/single/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__Quotes__SingleQuote__model.js' */ '/app/src/pages/Quotes/SingleQuote/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../Quotes/SingleQuote'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Quotes/SingleQuote').default,
                hideInMenu: true,
                exact: true,
              },
              {
                name: 'Draft',
                path: '/quotes/draft',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../Quotes'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Quotes').default,
                qs: 'page=1&pageSize=10&sorting=creationTime:desc',
                exact: true,
              },
              {
                name: 'Pending Quotes',
                path: '/quotes/pending',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../Quotes'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Quotes').default,
                qs: 'page=1&pageSize=10&sorting=creationTime:desc',
                authority: ['CoreService.Quotes'],
                exact: true,
              },
              {
                name: 'My Quick Quotes',
                icon: 'Thunder',
                path: '/my-quick-quotes',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../DealerQuickQuotes'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../DealerQuickQuotes').default,
                authority: ['PricingService.QuickQuotes'],
                exact: true,
              },
              {
                name: 'Completed',
                path: '/quotes/completed',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../Quotes'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Quotes').default,
                qs: 'page=1&pageSize=10&sorting=creationTime:desc',
                exact: true,
              },
              {
                name: 'Expired',
                path: '/quotes/expired',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../Quotes'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Quotes').default,
                qs: 'page=1&pageSize=10&sorting=creationTime:desc',
                exact: true,
              },
              {
                name: 'Completed',
                path: '/quotes/completed/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__ShipmentDetails__model.js' */ '/app/src/pages/ShipmentList/ShipmentDetails/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/ShipmentDetails'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/ShipmentDetails').default,
                hideInMenu: true,
                authority: ['CoreService.Shipments'],
                exact: true,
              },
              {
                name: 'Completed',
                path: '/quotes/admin/completed/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__AdminShipments__AdminShipmentView__model.js' */ '/app/src/pages/AdminShipments/AdminShipmentView/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../AdminShipments/AdminShipmentView'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../AdminShipments/AdminShipmentView').default,
                hideInMenu: true,
                authority: ['CoreService.AdminShipments'],
                exact: true,
              },
              {
                name: 'Shipment Details',
                path: '/quotes/pending/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__ShipmentDetails__model.js' */ '/app/src/pages/ShipmentList/ShipmentDetails/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/ShipmentDetails'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/ShipmentDetails').default,
                hideInMenu: true,
                exact: true,
              },
              {
                name: 'Shipment Details',
                path: '/quotes/admin/pending/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__ShipmentDetails__model.js' */ '/app/src/pages/ShipmentList/ShipmentDetails/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/ShipmentDetails'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/ShipmentDetails').default,
                hideInMenu: true,
                exact: true,
              },
              {
                name: 'Quotes View',
                path: '/quotes/:path/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__ShipmentDetails__model.js' */ '/app/src/pages/ShipmentList/ShipmentDetails/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/ShipmentDetails'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/ShipmentDetails').default,
                hideInMenu: true,
                exact: true,
              },
            ],
          },
          {
            name: 'Transporter Details',
            path: '/dealer/transporter/view',
            authority: ['CoreService.Transporters'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__ShipmentList__TransporterDetails" */ '../ShipmentList/TransporterDetails'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../ShipmentList/TransporterDetails').default,
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Dealer Shipments',
            icon: 'carry-out',
            path: '/shipments',
            authority: ['CoreService.Shipments'],
            routes: [
              {
                path: '/shipments',
                redirect: '/shipments/dealer/all',
                exact: true,
              },
              {
                name: 'All Shipments',
                path: '/shipments/dealer/all',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList').default,
                exact: true,
              },
              {
                name: 'Posted',
                path: '/shipments/dealer/posted',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList').default,
                exact: true,
              },
              {
                name: 'Assigned',
                path: '/shipments/dealer/assigned',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList').default,
                exact: true,
              },
              {
                name: 'Delivered',
                path: '/shipments/dealer/delivered',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList').default,
                exact: true,
              },
              {
                name: 'Shipment Details',
                path: '/shipments/dealer/:path/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__ShipmentDetails__model.js' */ '/app/src/pages/ShipmentList/ShipmentDetails/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/ShipmentDetails'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/ShipmentDetails').default,
                hideInMenu: true,
                exact: true,
              },
              {
                name: 'Edit Shipment',
                path: '/shipments/dealer/edit',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__EditShipment__model.js' */ '/app/src/pages/ShipmentList/EditShipment/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/EditShipment'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/EditShipment').default,
                hideInMenu: true,
                exact: true,
              },
            ],
          },
          {
            name: 'Transporter Loads',
            icon: 'reconciliation',
            path: '/loads',
            authority: [
              'CoreService.AvailableLoads',
              'CoreService.AssignedLoads',
            ],
            routes: [
              {
                path: '/loads',
                redirect: '/loads/all',
                exact: true,
              },
              {
                name: 'Available Shipments',
                subname: 'Loads',
                path: '/loads/shipments',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../AvailableShipments'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../AvailableShipments').default,
                authority: ['CoreService.AvailableLoads'],
                exact: true,
              },
              {
                name: 'Shipment Details',
                path: '/loads/shipments/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__ShipmentList__TransporterShipmentView__model.js' */ '/app/src/pages/ShipmentList/TransporterShipmentView/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../ShipmentList/TransporterShipmentView'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../ShipmentList/TransporterShipmentView').default,
                hideInMenu: true,
                authority: ['CoreService.AvailableLoads'],
                exact: true,
              },
              {
                name: 'All Loads',
                subname: 'Loads',
                path: '/loads/all',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../TransporterLoads'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../TransporterLoads').default,
                authority: ['CoreService.AssignedLoads'],
                exact: true,
              },
              {
                name: 'In Progress',
                subname: 'Loads',
                path: '/loads/progress',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../TransporterLoads'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../TransporterLoads').default,
                authority: ['CoreService.AssignedLoads'],
                exact: true,
              },
              {
                name: 'Delivered',
                subname: 'Loads',
                path: '/loads/delivered',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../TransporterLoads'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../TransporterLoads').default,
                authority: ['CoreService.AssignedLoads'],
                exact: true,
              },
              {
                name: 'Completed',
                subname: 'Loads',
                path: '/loads/completed',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../TransporterLoads'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../TransporterLoads').default,
                authority: ['CoreService.AssignedLoads'],
                exact: true,
              },
              {
                name: 'Transporter Loads Details',
                path: '/loads/:path/view',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__TransporterLoads__LoadsView__model.js' */ '/app/src/pages/TransporterLoads/LoadsView/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../TransporterLoads/LoadsView'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../TransporterLoads/LoadsView').default,
                hideInMenu: true,
                authority: ['CoreService.AssignedLoads'],
                exact: true,
              },
            ],
          },
          {
            name: 'Vehicle Details',
            path: '/vehicles/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Vehicles__VehicleView__model.js' */ '/app/src/pages/Vehicles/VehicleView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Vehicles__VehicleView" */ '../Vehicles/VehicleView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Vehicles/VehicleView').default,
            hideInMenu: true,
            authority: [
              'CoreService.AdminShipments.Vehicles',
              'CoreService.Shipments.Vehicles',
              'CoreService.AvailableLoads',
              'CoreService.AssignedLoads',
            ],
            exact: true,
          },
          {
            name: 'Edit Vehicle',
            path: '/vehicles/edit',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Vehicles__EditVehicle__model.js' */ '/app/src/pages/Vehicles/EditVehicle/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Vehicles__EditVehicle" */ '../Vehicles/EditVehicle'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Vehicles/EditVehicle').default,
            authority: [
              'CoreService.Shipments.Vehicles.Edit',
              'CoreService.AdminShipments.Vehicles.Edit',
            ],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Dealer Reports',
            icon: 'AreaChartOutlined',
            path: '/dealer/reports',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Reports" */ '../Reports'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Reports').default,
            authority: ['CoreService.Reports.Dealer'],
            exact: true,
          },
          {
            name: 'Transporter Reports',
            icon: 'BarChartOutlined',
            path: '/transporter/reports',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Reports" */ '../Reports'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Reports').default,
            authority: ['CoreService.Reports.Transporter'],
            exact: true,
          },
          {
            name: 'Shipper Intelligence',
            icon: 'project',
            path: '/dealer/shipperintelligence',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__GroupReports" */ '../GroupReports'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../GroupReports').default,
            authority: ['CoreService.Reports.ShipperIntelligence'],
            exact: true,
          },
          {
            name: 'Settings',
            icon: 'setting',
            path: '/settings',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Settings" */ '../Settings'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Settings').default,
            hideInMenu: true,
            authority: ['IdentityService.Profiles', 'CoreService.Companies'],
            exact: true,
          },
          {
            name: 'Notifications',
            path: '/notifications',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Notifications" */ '../Notifications'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Notifications').default,
            hideInMenu: true,
            authority: ['NotificationService.UserNotificationSettings'],
            exact: true,
          },
          {
            name: 'Dealer View',
            path: '/settings/dealer',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Settings__components__SingleDealerView__model.js' */ '/app/src/pages/Settings/components/SingleDealerView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Settings__components__SingleDealerView" */ '../Settings/components/SingleDealerView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Settings/components/SingleDealerView').default,
            hideInMenu: true,
            authority: ['CoreService.Companies'],
            exact: true,
          },
          {
            name: 'Transporter View',
            path: '/settings/transporter',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Settings__components__SingleTransporterView__model.js' */ '/app/src/pages/Settings/components/SingleTransporterView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Settings__components__SingleTransporterView" */ '../Settings/components/SingleTransporterView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Settings/components/SingleTransporterView').default,
            hideInMenu: true,
            authority: ['CoreService.Companies'],
            exact: true,
          },
          {
            name: 'Pricing History',
            icon: 'dollar',
            path: '/admin/pricinghistory',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminPricingHistory" */ '../AdminPricingHistory'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminPricingHistory').default,
            authority: ['CoreService.PricingHistories'],
            exact: true,
          },
          {
            name: 'Dealer Entities',
            icon: 'contacts',
            path: '/admin/dealers',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Dealers" */ '../Dealers'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Dealers').default,
            qs: 'page=1&pageSize=10&filters=flagStatus:1_',
            authority: ['CoreService.Dealers'],
            exact: true,
          },
          {
            name: 'Add Dealer',
            icon: 'contacts',
            path: '/admin/dealers/add',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Dealers__AddDealer" */ '../Dealers/AddDealer'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Dealers/AddDealer').default,
            hideInMenu: true,
            authority: ['CoreService.Dealers.Create'],
            exact: true,
          },
          {
            name: 'Dealer View',
            path: '/admin/dealers/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Dealers__SingleDealer__model.js' */ '/app/src/pages/Dealers/SingleDealer/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Dealers__SingleDealer" */ '../Dealers/SingleDealer'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Dealers/SingleDealer').default,
            authority: ['CoreService.Dealers'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Pricing Strategies',
            path: '/admin/dealers/strategies',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Dealers__SingleDealer__model.js' */ '/app/src/pages/Dealers/SingleDealer/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Dealers__SingleDealer__Strategies" */ '../Dealers/SingleDealer/Strategies'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Dealers/SingleDealer/Strategies').default,
            authority: ['PricingService.PricingSettings'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Transporter Entities',
            icon: 'contacts',
            path: '/admin/transporters',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Transporters" */ '../Transporters'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Transporters').default,
            authority: ['CoreService.Transporters'],
            exact: true,
          },
          {
            name: 'Transporter View',
            path: '/admin/transporters/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__Transporters__SingleTransporter__model.js' */ '/app/src/pages/Transporters/SingleTransporter/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__Transporters__SingleTransporter" */ '../Transporters/SingleTransporter'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Transporters/SingleTransporter').default,
            authority: ['CoreService.Transporters'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Add Transporter',
            icon: 'contacts',
            path: '/admin/transporters/add',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Transporters__AddTransporter" */ '../Transporters/AddTransporter'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Transporters/AddTransporter').default,
            hideInMenu: true,
            authority: ['CoreService.Transporters.Create'],
            exact: true,
          },
          {
            name: 'Users',
            icon: 'user',
            path: '/admin/users',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Users" */ '../Users'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Users').default,
            qs: 'page=1&pageSize=10&filters=isActive:true_',
            authority: ['IdentityService.User'],
            exact: true,
          },
          {
            name: 'Users View',
            path: '/admin/users/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Users__SingleUser" */ '../Users/SingleUser'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Users/SingleUser').default,
            authority: ['IdentityService.User'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Add User',
            path: '/admin/users/add',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Users__AddUser" */ '../Users/AddUser'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Users/AddUser').default,
            authority: ['IdentityService.User'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Admin Users',
            icon: 'user',
            path: '/admin/adminusers',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminUsers" */ '../AdminUsers'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminUsers').default,
            qs: 'page=1&pageSize=10&filters=isActive:true_',
            authority: ['IdentityService.AdminUser'],
            exact: true,
          },
          {
            name: 'Admin Users View',
            icon: 'user',
            path: '/admin/adminusers/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminUsers__SingleUser" */ '../AdminUsers/SingleUser'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminUsers/SingleUser').default,
            authority: ['IdentityService.AdminUser'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Add Admin User',
            path: '/admin/adminusers/add-admin',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Users__AddUser" */ '../Users/AddUser'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Users/AddUser').default,
            authority: ['IdentityService.AdminUser'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'SecurePass™ Logs',
            icon: 'safety',
            path: '/admin/secure-pass-logs',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminSecurePassLogs" */ '../AdminSecurePassLogs'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminSecurePassLogs').default,
            authority: ['MediaService.SecurePassLogs'],
            exact: true,
          },
          {
            name: 'Address Book',
            icon: 'book',
            path: '/addresses',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AddressBook" */ '../AddressBook'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AddressBook').default,
            authority: ['CoreService.Addresses'],
            exact: true,
          },
          {
            name: 'Address Book View',
            path: '/addresses/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AddressBook__AddressView__model.js' */ '/app/src/pages/AddressBook/AddressView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AddressBook__AddressView" */ '../AddressBook/AddressView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AddressBook/AddressView').default,
            authority: ['CoreService.Addresses'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Add User',
            icon: 'user-add',
            path: '/add-user',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Settings__components__AddUser" */ '../Settings/components/AddUser'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Settings/components/AddUser').default,
            authority: ['CoreService.Companies.Users.Create'],
            exact: true,
          },
          {
            name: 'Entity Groups',
            icon: 'team',
            path: '/admin/entitygroups',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminEntityGroups" */ '../AdminEntityGroups'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminEntityGroups').default,
            authority: ['CoreService.CompanyGroups'],
            exact: true,
          },
          {
            name: 'Entity Groups View',
            path: '/admin/entitygroups/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminEntityGroups__AdminEntityGroupView__model.js' */ '/app/src/pages/AdminEntityGroups/AdminEntityGroupView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminEntityGroups__AdminEntityGroupView" */ '../AdminEntityGroups/AdminEntityGroupView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminEntityGroups/AdminEntityGroupView').default,
            authority: ['CoreService.CompanyGroups'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Entity Groups Pricing Strategies',
            path: '/admin/entitygroups/strategies',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminEntityGroups__AdminEntityGroupView__model.js' */ '/app/src/pages/AdminEntityGroups/AdminEntityGroupView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminEntityGroups__AdminEntityGroupView__Strategies" */ '../AdminEntityGroups/AdminEntityGroupView/Strategies'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminEntityGroups/AdminEntityGroupView/Strategies')
                  .default,
            authority: ['CoreService.CompanyGroups'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'Payments',
            path: '/admin/payments',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminPricing" */ '../AdminPricing'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminPricing').default,
            authority: ['CoreService.Payments'],
            icon: 'dollar',
            exact: true,
          },
          {
            name: 'Payments View',
            path: '/admin/payments/view',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminPricing__AdminPricingView__model.js' */ '/app/src/pages/AdminPricing/AdminPricingView/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminPricing__AdminPricingView" */ '../AdminPricing/AdminPricingView'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminPricing/AdminPricingView').default,
            authority: ['CoreService.Payments'],
            hideInMenu: true,
            exact: true,
          },
          {
            name: 'WWL/Nissan',
            path: '/admin/wwl-nissan',
            icon: 'deployment-unit',
            authority: [
              'NissanService.Dealers',
              'NissanService.Colors',
              'NissanService.Dealers',
              'NissanService.Models',
              'NissanService.Vehicles',
              'NissanService.VPCLocations',
            ],
            routes: [
              {
                name: 'Tender File Input',
                path: '/admin/wwl-nissan/tender-file-input',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/TenderFileInput'),
                      LoadingComponent: require('/app/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../WWLNissan/TenderFileInput').default,
                authority: ['NissanService.Vehicles'],
                icon: 'profile',
                qs: 'page=1&pageSize=10&filters=nissanVehicleStatus:1_',
                exact: true,
              },
              {
                name: 'Nissan Dealers',
                icon: 'carry-out',
                path: '/admin/wwl-nissan/nissan-dealers',
                authority: ['NissanService.Dealers'],
                routes: [
                  {
                    path: '/admin/wwl-nissan/nissan-dealers',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/NissanDealers'),
                          LoadingComponent: require('/app/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../WWLNissan/NissanDealers').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Nissan Colors',
                icon: 'carry-out',
                path: '/admin/wwl-nissan/nissan-colors',
                authority: ['NissanService.Colors'],
                routes: [
                  {
                    path: '/admin/wwl-nissan/nissan-colors',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__WWLNissan__NissanColors__model.js' */ '/app/src/pages/WWLNissan/NissanColors/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/NissanColors'),
                          LoadingComponent: require('/app/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../WWLNissan/NissanColors').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Tender Models',
                icon: 'carry-out',
                path: '/admin/wwl-nissan/nissan-models',
                authority: ['NissanService.Models'],
                routes: [
                  {
                    path: '/admin/wwl-nissan/nissan-models',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/NissanModels'),
                          LoadingComponent: require('/app/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../WWLNissan/NissanModels').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Nissan Pricing',
                icon: 'carry-out',
                path: '/admin/wwl-nissan/nissan-pricing',
                authority: ['NissanService.Prices'],
                routes: [
                  {
                    path: '/admin/wwl-nissan/nissan-pricing',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/NissanPricing'),
                          LoadingComponent: require('/app/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../WWLNissan/NissanPricing').default,
                    exact: true,
                  },
                ],
              },
              {
                name: 'Nissan VPC Locations',
                icon: 'carry-out',
                path: '/admin/wwl-nissan/nissan-vpc-locations',
                authority: ['NissanService.VPCLocations'],
                routes: [
                  {
                    path: '/admin/wwl-nissan/nissan-vpc-locations',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__WWLNissan__model.js' */ '/app/src/pages/WWLNissan/model.js').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../WWLNissan/NissanVPCLocations'),
                          LoadingComponent: require('/app/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../WWLNissan/NissanVPCLocations').default,
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'External Tools',
            icon: 'book',
            path: '/admin/external',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AdminExternalTool__model.js' */ '/app/src/pages/AdminExternalTool/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AdminExternalTool" */ '../AdminExternalTool'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminExternalTool').default,
            authority: ['CoreService.ExternalTools'],
            exact: true,
          },
          {
            name: 'Tags',
            icon: 'tags',
            path: '/admin/tags',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__AdminTags" */ '../AdminTags'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../AdminTags').default,
            authority: ['TagService.Tags'],
            exact: true,
          },
          {
            name: 'Gate Passes',
            icon: 'GatePass',
            path: '/admin/gate-passes',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__GatePasses" */ '../GatePasses'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../GatePasses').default,
            authority: [
              'GatePassService.ProcessingJobs',
              'GatePassService.ProcessingResults',
            ],
            exact: true,
          },
          {
            name: 'Campaigns',
            icon: 'Megaphone',
            path: '/admin/campaigns',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Campaigns" */ '../Campaigns'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Campaigns').default,
            authority: ['AdministrationService.Campaigns'],
            exact: true,
          },
          {
            name: 'Contact Us',
            icon: 'mail',
            path: '/contact-support',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__ContactUs" */ '../ContactUs'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../ContactUs').default,
            authority: ['CoreService.ContactUs'],
            exact: true,
          },
          {
            name: 'Fallback',
            path: '/fallback',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Fallback" */ '../Fallback'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../Fallback').default,
            hideInMenu: true,
            authority: true,
            exact: true,
          },
          {
            path: '/401',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__401" */ '../401'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../401').default,
            cannotRedirectTo: true,
            exact: true,
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__404" */ '../404'),
                  LoadingComponent: require('/app/src/components/PageLoading/index')
                    .default,
                })
              : require('../404').default,
            cannotRedirectTo: true,
            exact: true,
          },
        ],
      },
      {
        path: '/401',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__401" */ '../401'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../401').default,
        cannotRedirectTo: true,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404'),
              LoadingComponent: require('/app/src/components/PageLoading/index')
                .default,
            })
          : require('../404').default,
        cannotRedirectTo: true,
        exact: true,
      },
    ],
  },
  {
    path: '/401',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import(/* webpackChunkName: "p__401" */ '../401'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../401').default,
    cannotRedirectTo: true,
    public: true,
    exact: true,
  },
  {
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import(/* webpackChunkName: "p__404" */ '../404'),
          LoadingComponent: require('/app/src/components/PageLoading/index')
            .default,
        })
      : require('../404').default,
    cannotRedirectTo: true,
    public: true,
    exact: true,
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
